import INetworkDto from "../../interfaces/network/INetworkDto";
import { cryptoPortfolioService } from "../httpService/cryptoPorfolio.service";

export async function tryGetNetworkList() {
    return await cryptoPortfolioService.get<INetworkDto[]>('/network/getnetworklist');
}
